import { gql } from '@apollo/client';

const PartnerContactInfo = gql`
  fragment PartnerContactInfo on PartnerContact {
    id
    firstName
    lastName
    email
    phone
    state
    partnerLocationId
    partnerOrganizationId
    partnerLocation {
      id
      name
    }
    partnerOrganization {
      id
      name
    }
    partnerContactCategories {
      id
      name
    }
    partnerContactCategoryIds
    createdAt
    updatedAt
  }
`;

export default PartnerContactInfo;
